import { createPerformanceObserver } from 'owa-analytics/lib/utils/factory';

let readingPaneKeyResourceNWInfo = undefined;
let observer = undefined;
let durationPromise = undefined;

/**
 * This method returns the duration of a reading pane exclusive file
 * by tracking load of it using perf observer
 * This will help in analytics where duration and transfer size can be used to decide if
 * it was served from cache or not.
 */
export async function getReadingPaneKeyResourceNWInfo() {
    const fileToCheck = 'owa.ReadingPane.js';
    if (!durationPromise) {
        durationPromise = new Promise((resolve, reject) => {
            try {
                const entryType = 'resource';

                // Register the Perf observer
                observer = createPerformanceObserver(entryType, list => {
                    const entries = list.getEntries();
                    for (let index = 0; index < entries.length; index++) {
                        const name = entries[index].name;
                        if (name.indexOf(fileToCheck) !== -1) {
                            observer?.disconnect();
                            return resolve(entries[index]);
                        }
                    }
                });
                observer ? observer.observe({ buffered: true, type: entryType }) : resolve(null);
            } catch (error) {
                resolve(null);
            }
        });
    }

    const result = (await durationPromise) as PerformanceResourceTiming;
    readingPaneKeyResourceNWInfo = result
        ? {
              /** Reading pane exclusive resource download duration */
              dd: result.duration,

              /** Reading pane exclusive resource transfer size */
              ts: result.transferSize,

              /** Reading pane exclusive decoded body size */
              ds: result.decodedBodySize,
          }
        : null;
    return Promise.resolve(readingPaneKeyResourceNWInfo);
}

export function logReadingPaneKeyResourceNWInfo() {
    return readingPaneKeyResourceNWInfo;
}
